import React from 'react';
import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { ServiceTypeDetail } from './PosListViewUtils';
import { APP_ROUTES, SERVICE_TYPES } from '../../../config/constants';
import { Link } from 'react-router-dom';
import settingsIcon from "../../assets/svg/Settings.svg";
import { generateElementIdentifier } from 'utils/ApplicationUtils';
import { DATA_IDENTIFIER, ELEMENT } from 'components/common/App/app-constant';

interface POSListTableInterface {
    rowsData: any[];
    columnsData: string[];
    classes: any;
}
const POSListTable = (props: POSListTableInterface) => {
    const { rowsData, columnsData, classes } = props;

    return (
        <Table data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.POS_LIST, element: ELEMENT.TABLE})} padding="none" size="small" stickyHeader={true}>
            <TableHead>
                <TableRow>
                    {columnsData.map((column: string) => (
                        <TableCell key={column} className={classes.cellHeaderStyle}>
                            {column}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {rowsData.map((row: any, index: number) => (
                    <TableRow data-testid={generateElementIdentifier({key: row?.posNo, element: ELEMENT.TABLE_ROW})} key={`${index}-${row?.posNo ?? ""}`}>
                        <TableCell data-testid={generateElementIdentifier({key: row?.posNo, element: ELEMENT.TABLE_CELL})} className={classes.cellDataStyle}>
                            {row?.posNo ?? ""}
                        </TableCell>
                        <TableCell data-testid={generateElementIdentifier({key: row?.storeName, element: ELEMENT.TABLE_CELL})} className={classes.cellDataStyle}>
                            {row?.storeName ?? ""}
                        </TableCell>
                        <TableCell data-testid={generateElementIdentifier({key: row?.posType, customKey: row?.posNo, element: ELEMENT.TABLE_CELL})} className={classes.cellDataStyle}>
                            {row?.posType ?? ""}
                        </TableCell>
                        <TableCell data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.SERVICE_TYPE, customKey: row?.posNo, element: ELEMENT.TABLE_CELL})} className={classes.cellDataStyle}>
                            <Grid container spacing={2} className={classes.serviceTypeContainer}>
                                {row?.serviceTypeList?.map((element: ServiceTypeDetail, index: number) => {
                                    const serviceTypeName =
                                        element?.type === SERVICE_TYPES.FBC
                                            ? element.type
                                            : element?.displayName || element?.type || "";

                                    const statusClass = element.status
                                        ? classes.activeServiceTypes
                                        : classes.inactiveServiceTypes;

                                    const marginClass = index !== 0 ? classes.leftMargin8 : "";

                                    return (
                                        <div key={`${element.type}-${index}`} className={`${statusClass} ${marginClass}`}>
                                            <div className={classes.serviceType}>
                                                {serviceTypeName}
                                            </div>
                                        </div>
                                    );
                                })}
                            </Grid>
                        </TableCell>
                        <TableCell data-testid={generateElementIdentifier({key: DATA_IDENTIFIER.SETTINGS, customKey: row?.posNo, element: ELEMENT.TABLE_CELL})} className={classes.cellDataStyle}>
                            <Link to={`${APP_ROUTES.COMPLETE_SETUP}/${row?.posNo}`} className={classes.completeSetupSettingsButton}>
                                <img src={settingsIcon} alt="settings" />
                            </Link>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}

export default POSListTable;